export default {"src":"/_next/static/media/ic_verified_badge_medium.762d5f59.svg","height":35,"width":36};